import i18n from '../i18n/config';
import { updateUserLanguage } from '../services/api';

export const PLATFORM_LANGUAGES = ['en', 'ar', 'fr'];

export function normalizePlatformLanguage(lng) {
  const code = String(lng || '').split('-')[0];
  return PLATFORM_LANGUAGES.includes(code) ? code : 'en';
}

export async function applyPlatformLanguage(newLang) {
  const lang = normalizePlatformLanguage(newLang);
  if (normalizePlatformLanguage(i18n.language) === lang) {
    return lang;
  }

  await i18n.changeLanguage(lang);
  localStorage.setItem('language', lang);

  try {
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    if (user && typeof user === 'object') {
      localStorage.setItem('user', JSON.stringify({ ...user, language: lang }));
      if (user.id) {
        updateUserLanguage(user.id, lang).catch((error) => {
          console.error('Failed to sync language to backend:', error);
        });
      }
    }
  } catch (error) {
    console.error('Failed to persist language preference:', error);
  }

  if (typeof document !== 'undefined') {
    const { setDirection } = await import('./dirManager');
    const { loadFontForLanguage } = await import('./fontLoader');
    setDirection(lang);
    loadFontForLanguage(lang);
    window.dispatchEvent(new CustomEvent('languageChanged', { detail: { language: lang } }));
  }

  return lang;
}
